export const JOIN_ORGANIZATION_SCREEN = 'JOIN_ORGANIZATION_SCREEN';
export const CALL_TO_ACTION_SCREEN = 'CALL_TO_ACTION_SCREEN';
export const ENTRY_INFO_SCREEN = 'ENTRY_INFO_SCREEN';
export const MOL_BIO_INFO_SCREEN = 'MOL_BIO_INFO_SCREEN';
export const ROLE_INFO_SCREEN = 'ROLE_INFO_SCREEN';
export const ROLE_INFO_SCREEN_WITHOUT_FLOW = 'ROLE_INFO_SCREEN_WITHOUT_FLOW';

export const SIGNUP_FLOW_V2_AFFILIATION_SCREEN = 'SIGNUP_FLOW_V2_AFFILIATION_SCREEN';
export const SIGNUP_FLOW_V2_ACADEMIC_ROLE_INFO_SCREEN = 'SIGNUP_FLOW_V2_ACADEMIC_ROLE_INFO_SCREEN';
export const SIGNUP_FLOW_V2_INDUSTRY_ROLE_INFO_SCREEN = 'SIGNUP_FLOW_V2_INDUSTRY_ROLE_INFO_SCREEN';
export const SIGNUP_FLOW_V2_JOIN_ORGANIZATION_SCREEN = 'SIGNUP_FLOW_V2_JOIN_ORGANIZATION_SCREEN';
export const SIGNUP_FLOW_V2_MOLBIO_OR_NOTEBOOK_SCREEN = 'SIGNUP_FLOW_V2_MOLBIO_OR_NOTEBOOK_SCREEN';

export const TERMINAL_SCREENS = [CALL_TO_ACTION_SCREEN, SIGNUP_FLOW_V2_MOLBIO_OR_NOTEBOOK_SCREEN];

export const ALL_SCREENS = [
  JOIN_ORGANIZATION_SCREEN,
  CALL_TO_ACTION_SCREEN,
  ENTRY_INFO_SCREEN,
  MOL_BIO_INFO_SCREEN,
  ROLE_INFO_SCREEN,
  ROLE_INFO_SCREEN_WITHOUT_FLOW,
  SIGNUP_FLOW_V2_AFFILIATION_SCREEN,
  SIGNUP_FLOW_V2_ACADEMIC_ROLE_INFO_SCREEN,
  SIGNUP_FLOW_V2_INDUSTRY_ROLE_INFO_SCREEN,
  SIGNUP_FLOW_V2_JOIN_ORGANIZATION_SCREEN,
  SIGNUP_FLOW_V2_MOLBIO_OR_NOTEBOOK_SCREEN,
] as const;

export type NewUserFlowScreen = (typeof ALL_SCREENS)[number];

export const LAB_NOTEBOOK_FLOW = 'LAB_NOTEBOOK_FLOW';
export const MOL_BIO_FLOW = 'MOL_BIO_FLOW';

export type NewUserFlow = typeof LAB_NOTEBOOK_FLOW | typeof MOL_BIO_FLOW;

export const FLOWS = {
  [LAB_NOTEBOOK_FLOW]: [ENTRY_INFO_SCREEN],
  [MOL_BIO_FLOW]: [MOL_BIO_INFO_SCREEN],
};

export const SCREEN_TO_ANALYTICS_NAME: {[screen: string]: string} = {
  JOIN_ORGANIZATION_SCREEN: 'join_organization',
  CALL_TO_ACTION_SCREEN: 'choose_cta',
  ENTRY_INFO_SCREEN: 'notebook_overview',
  MOL_BIO_INFO_SCREEN: 'molecular_biology_overview',
  SIGNUP_FLOW_V2_AFFILIATION_SCREEN: 'affiliation',
  SIGNUP_FLOW_V2_ACADEMIC_ROLE_INFO_SCREEN: 'academic_role_info',
  SIGNUP_FLOW_V2_INDUSTRY_ROLE_INFO_SCREEN: 'industry_role_info',
  SIGNUP_FLOW_V2_JOIN_ORGANIZATION_SCREEN: 'join_organization',
  SIGNUP_FLOW_V2_MOLBIO_OR_NOTEBOOK_SCREEN: 'molbio_or_notebook',
};
